import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {CountryCode} from "../../shipper";
import {countries} from "../countries";
import {NgForOf} from "@angular/common";
import {FormsModule} from "@angular/forms";



@Component({
	selector: 'country-select',
	standalone: true,
	imports: [
		NgForOf,
		FormsModule
	],
	template: `
        <div>
            <select class="form-control form-control-sm" (change)="onSelected($event)">
                <option *ngFor="let c of countryData" [value]="c.code" [selected]="c.code == selectedCountryCode">{{c.name}}</option>
            </select>
        </div>
	`
})
export class CountryCodeSelect implements OnInit{
	
	countryCodeModel:Array<CountryCode> = [];
	
	
	private canadaData :Array<CountryCode>= [
		{code:"XA", name: "Alberta"},
		{code:"XB", name: "New Brunswick"},
		{code:"XC", name: "British Columbia"},
		{code:"XM", name: "Manitoba"},
		{code:"XN", name: "Nova Scotia"},
		{code:"XO", name: "Ontario"},
		{code:"XP", name: "Prince Edward Island"},
		{code:"XQ", name: "Quebec"},
		{code:"XS", name: "Saskatchewan"},
		{code:"XT", name: "Northwest Territories"},
		{code:"XV", name: "Nunavut"},
		{code:"XW", name: "Newfoundland"},
		{code:"XY", name: "Yukon Territory"}
	];
	
	public  countryData : Array<CountryCode> = [];
	
	@Input()
	public selectedCountryCode!:string|null;
	
	@Output()
	private selectedCountryCodeChange:EventEmitter<string|null> = new EventEmitter<string|null>();
	
	@Input()
	includeCanadian:boolean = false;
	
	
	
	constructor() {
		
		// @ts-ignore
		this.countryData = Object.keys(countries).map((c) => ({code:c, name:countries[c]}));
		
		this.countryData.forEach((c) => c.name = `(${c.code}) ${c.name}`);
	}
	
	
	
	ngOnInit(): void {
		if(this.selectedCountryCode !== null && this.selectedCountryCode !== ''){
			//this.countryCodeModel[0] = this.getCountry(this.selectedCountryCode);
		}
		
		if(this.canadaData){
			this.canadaData.forEach((c) =>
				this.countryData.push({code:c.code, name:`(${c.code}) ${c.name} (Canada)`}));
		}
	}
	
	getCountry(code:string){
		return this.countryData
			.find(c => c.code === code);
	}
	
	
	onSelected(ev:any){
	
		console.log(ev);
		
		// @ts-ignore
		this.selectedCountryCode = ev.code;
		//this.countryCodeModel[0] = ev;
		this.selectedCountryCodeChange.emit(this.selectedCountryCode);
	}
	
}
